export const APP_TASK_TABLE_CONFIG = (intl) => [
  {
    key: 'tipologia_nombre',
    label: intl.formatMessage({ id: 'pages.application.detail.history.tableFields.tipo' }),
  },
  {
    key: 'documento_campo',
    label: intl.formatMessage({
      id: 'pages.application.detail.history.tableFields.documento_campo',
    }),
  },
  {
    key: 'estado_nombre',
    label: intl.formatMessage({ id: 'pages.application.detail.history.tableFields.estado' }),
  },
  {
    key: 'dg_ts_insert',
    label: intl.formatMessage({ id: 'pages.application.detail.history.tableFields.fecha' }),
    type: 'datetime',
  },
  {
    key: 'observaciones_sspp',
    label:
      intl.formatMessage({ id: 'pages.application.detail.history.tableFields.observaciones' }) ||
      'Observaciones',
  },
]
